import React, { Fragment, useState } from 'react';
import './ListMembers.css';
import data from "./mock-data.json";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableOnlyRow";

export default function ListMembers() {

    const [contacts, setContacts] = useState(data);
    const [addFormData, setAddFormData] = useState({
        code: "",
        name: "",
        role: "",
        data: "",
        permissions: "",
        status1: "", status2: ""
    });
    const [editFormData, setEditFormData] = useState({
        code: "",
        name: "",
        role: "",
        data: "",
        permissions: "",
        status1: "", status2: ""

    });
    const [editContactId, setEditContactId] = useState(null);

    const handleAddFormChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.getAttribute("name");
        const fieldValue = event.target.value;

        const newFormData = { ...addFormData };
        newFormData[fieldName] = fieldValue;

        setAddFormData(newFormData);
    };
    const handleEditFormChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.getAttribute("name");
        const fieldValue = event.target.value;

        const newFormData = { ...editFormData };
        newFormData[fieldName] = fieldValue;

        setEditFormData(newFormData);
    };
    const handleAddFormSubmit = (event) => {
        event.preventDefault();
        const newContact = {
            code: addFormData.code,
            name: addFormData.name,
            role: addFormData.role,
            date: addFormData.date,
            permissions: addFormData.permissions,
            status1: addFormData.status1,
            status2: addFormData.status2

        };

        const newContacts = [...contacts, newContact];

        setContacts(newContacts);
    };
    const handleEditFormSubmit = (event) => {
        event.preventDefault();

        const editedContact = {
            code: editFormData.code,
            name: editFormData.name,
            role: editFormData.role,
            date: editFormData.date,
            permissions: editFormData.permissions,
            staus1: editFormData.status1,
            status2: editFormData.status2

        };
        const newContacts = [...contacts];

        const index = contacts.findIndex((contact) => contact.id === editContactId);

        newContacts[index] = editedContact;

        setContacts(newContacts);
        setEditContactId(null);
    };

    const handleEditClick = (event, contact) => {
        event.preventDefault();
        setEditContactId(contact.code);

        const formValues = {
            code: contact.code,
            name: contact.name,
            role: contact.role,
            date: contact.date,
            permissions: contact.permissions,
            status1: contact.status1,
            status2: contact.status2
        };

        setEditFormData(formValues);
    };
    const handleCancelClick = () => {
        setEditContactId(null);
    };

    const handleDeleteClick = (contactId) => {
        const newContacts = [...contacts];

        const index = contacts.findIndex((contact) => contact.code === contactId);

        newContacts.splice(index, 1);

        setContacts(newContacts);
    };

    return (
        <div className="ListMembers">
            {/* <!-- Top Bar --> */}
            <div className="container-fluid1 py-2 icueTopBarContainer bg-white">

                <div className="row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="topBarLfContainer d-flex">
                            <div className="icueLogoContainer">
                                <img src="images/logo.png" alt="ICue Logo" className="icueLogo" />
                            </div>
                            <div className="icueSearchBox w-75 mx-3">
                                <div className="input-group ">
                                    <span className="input-group-text" id="basic-addon1">
                                        <i className="bi bi-search"></i>
                                    </span>
                                    <input type="search" className="form-control icueSearchBoxControl" placeholder="Enter keywords..." aria-label="Username" aria-describedby="basic-addon1" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="d-flex flex-row-reverse">
                            <div className="icueProfile px-2">
                                <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" />
                            </div>
                            <div className="position-relative px-2">
                                <a href="#" id="icueNotifyBoxHandler">
                                    <i className="bi bi-bell">
                                        <span className="position-absolute icueNofIndic"></span>
                                    </i>
                                </a>
                                <div className="icueNotifyBox" id="icueNotifyBox">
                                    Notifications
                                </div>
                            </div>

                            <div className="icueUserName fs-6 px-2">
                                Viral Patel
                            </div>

                            <div className="icueMail px-2">
                                <i className="bi bi-headset"></i> &nbsp;
                                adminhelpdesk@gmail.com
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- /Top Bar -->

    <!-- Main Body --> */}
            <div className="container-fluid my-2">
                <div className="row">
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 bg-white">
                        <div className="icueRespSideBar d-xxl-none d-xl-none d-lg-none d-md-block d-sm-block d-block" id="icueRespSideBar">
                            <button type="button" className="btn btn-primary" id="icueRespHumburger">
                                <i className="bi bi-grid-3x3-gap"></i>
                            </button>
                            <div className="icueSideBar" id="icueSideBar">
                                <nav className="navbar icueSideNavContainer">
                                    <ul className="icueNavBarList">
                                        <li className="icueNavBarItem ">
                                            <a href="/Hrdashboard" className="icueNavBarLink" id="">Dashboard</a>
                                        </li>
                                        <li className="icueNavBarItem border-bottom-0">
                                            <a href="#" className="icueNavBarLink" id="">User Management</a>
                                        </li>

                                        <li>
                                            <ul className="icueSubNavBar">
                                                <li className="icueSubNavItem">
                                                    <a href="#" className="icueSubNavLink  text-capitalize">Add Members</a>
                                                </li>
                                                <li

                                                    className="active">
                                                    <ul className="icueSubNavBar">
                                                        <li className="icueSubNavItem" style={{ marginLeft: "-20px" }}>
                                                            <a href="/ListMembers" className="icueSubNavLink text-capitalize">List of Members</a>
                                                        </li>
                                                    </ul>
                                                </li>


                                            </ul>
                                        </li>
                                        <hr></hr>

                                        <li className="icueNavBarItem border-bottom-0">
                                            <a href="#" className="icueNavBarLink" id="">Leave Management</a>
                                        </li>

                                        <li>
                                            <ul className="icueSubNavBar">
                                                <li className="icueSubNavItem">

                                                    <a href="/Leaves" className="icueSubNavLink  text-capitalize">Leaves</a>
                                                </li>
                                                <li className="icueSubNavItem">
                                                    <a href="/LeaveType" className="icueSubNavLink  text-capitalize">Leave Type</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <hr></hr>
                                        <li className="icueNavBarItem border-bottom-1">
                                            <a href="/Holidays" className="icueNavBarLink" id="">Holidays</a>
                                        </li>
                                        <li className="icueNavBarItem border-bottom-1">
                                            <a href="#" className="icueNavBarLink" id="">Attendence</a>
                                        </li>



                                        <li className="icueNavBarItem">
                                            <a href="/Department" className="icueNavBarLink" id="">Department</a>
                                        </li>

                                        <li className="icueNavBarItem">
                                            <a href="/AddRoles" className="icueNavBarLink" id="">Roles</a>
                                        </li>

                                        <li className="icueNavBarItem border-bottom-0">
                                            <a href="#" className="icueNavBarLink" id="">Payroll</a>
                                        </li>
                                        <li>
                                            <ul className="icueSubNavBar">
                                                <li className="icueSubNavItem">
                                                    <a href="/EmpSalary" className="icueSubNavLink  text-capitalize">Employee Salary</a>
                                                </li>
                                                <li className="icueSubNavItem">
                                                    <a href="/Payitems" className="icueSubNavLink  text-capitalize">Payroll Items</a>
                                                </li>
                                            </ul>
                                            <hr></hr>
                                        </li>

                                        <li className="icueNavBarItem border-bottom-0" style={{ marginTop: "-18px" }}>
                                            <a href="#" className="icueNavBarLink" id="">Settings</a>
                                        </li>
                                        <li>
                                            <ul className="icueSubNavBar">
                                                <li className="icueSubNavItem">
                                                    <a href="#" className="icueSubNavLink  text-capitalize">Change Password</a>
                                                </li>
                                                <li className="icueSubNavItem">
                                                    <a href="#" className="icueSubNavLink  text-capitalize">Profile</a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>

                        <div className="icueNavSideBar d-xxl-block d-xl-block d-lg-block d-md-none d-sm-none d-none" id="icueNavSideBar">
                            <nav>
                                <ul className="icueNavBarList">
                                    <li className="icueNavBarItem">
                                        <a href="/Hrdashboard" className="icueNavBarLink" id="">Dashboard</a>
                                    </li>

                                    <li className="icueNavBarItem border-bottom-0">
                                        <a href="#" className="icueNavBarLink" id="">User Management</a>
                                    </li>

                                    <li>
                                        <ul className="icueSubNavBar">
                                            <li className="icueSubNavItem" style={{ marginTop: "-8px" }}>
                                                <a href="#" className="icueSubNavLink  text-capitalize">Add Member</a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="active">
                                        <ul className="icueSubNavBar">
                                            <li className="icueSubNavItem" style={{ marginTop: "2px", marginLeft: "-20px" }}>
                                                <a href="/ListMembers" className="icueSubNavLink  text-capitalize">List Of Members</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <hr></hr>

                                    <li className="icueNavBarItem border-bottom-0" style={{ marginTop: "-18px" }}>
                                        <a href="#" className="icueNavBarLink" id="" >Leave Management</a>
                                    </li>

                                    <li>
                                        <ul className="icueSubNavBar ">
                                            <li className="icueSubNavItem" style={{ marginTop: "-8px" }}>
                                                <a href="/Leaves" className="icueSubNavLink  text-capitalize">Leaves</a>
                                            </li>
                                            <li className="icueSubNavItem">
                                                <a href="/LeaveType" className="icueSubNavLink  text-capitalize">Leave Type</a>
                                            </li>
                                        </ul>
                                        <hr></hr>
                                    </li>

                                    <li className="icueNavBarItem " style={{ marginTop: "-18px" }}>
                                        <a href="/Holidays" className="icueNavBarLink" id="">Holidays</a>
                                    </li>
                                    <li className="icueNavBarItem ">
                                        <a href="#" className="icueNavBarLink" id="">Attendence</a>
                                    </li>




                                    <li className="icueNavBarItem" >
                                        <a href="/Department" className="icueNavBarLink" id="">Department</a>
                                    </li>

                                    <li className="icueNavBarItem">
                                        <a href="/AddRoles" className="icueNavBarLink" id="">Roles</a>
                                    </li>


                                    <li className="icueNavBarItem border-bottom-0">
                                        <a href="#" className="icueNavBarLink" id="">Payroll</a>
                                    </li>
                                    <li>
                                        <ul className="icueSubNavBar">
                                            <li className="icueSubNavItem">
                                                <a href="/EmpSalary" className="icueSubNavLink  text-capitalize">Employee Salary</a>
                                            </li>
                                            <li className="icueSubNavItem">
                                                <a href="/Payitems" className="icueSubNavLink  text-capitalize">Payroll Items</a>
                                            </li>
                                        </ul>
                                        <hr></hr>
                                    </li>

                                    <li className="icueNavBarItem border-bottom-0" style={{ marginTop: "-18px" }}>
                                        <a href="#" className="icueNavBarLink" id="">Settings</a>
                                    </li>
                                    <li>
                                        <ul className="icueSubNavBar">
                                            <li className="icueSubNavItem">
                                                <a href="#" className="icueSubNavLink  text-capitalize">Change Password</a>
                                            </li>
                                            <li className="icueSubNavItem">
                                                <a href="#" className="icueSubNavLink  text-capitalize">Profile</a>
                                            </li>
                                        </ul>
                                        <hr></hr>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                    <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 ">

                        <main className="mainBodyContainer">
                            <div className="row my-2">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-2 px-3">
                                    <div className="d-flex justify-content-between">
                                        <h4 className="text-captalize" style={{ fontFamily: "ErasDemiITC", fontWeight: "bold", marginTop: "1rem", marginLeft: "12px" }}>List of Members</h4>
                                        <div className="bg-transparent p-2  rounded-3">

                                            <nav style={{ bsbreadcrumbdivider: 'url(&#34;"data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="8" height="8"%3E%3Cpath d="M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z" fill="currentColor"/%3E%3C/svg%3E&#34")' }} aria-label="breadcrumb">
                                                <ol className="breadcrumb mb-0">
                                                    <li className="breadcrumb-item bg-transparent" style={{ fontFamily: "Calibri", fontSize: "bold" }}><a href="/Superdashboard" className="text-decoration-none text-info">Dashboard</a></li>
                                                    <li className="breadcrumb-item bg-transparent" style={{ fontFamily: "Calibri" }}><a href="/lms" className="text-decoration-none text-info">User Mangement</a></li>
                                                    <li className="breadcrumb-item text-muted text-capitalize bg-transparent" aria-current="page" style={{ fontSize: "bold" }}>List of Members</li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                </div>

                                <div className="row my-2">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 py-2 px-2">
                                        <div className="bg-white p-2  rounded-3 shadow-sm" style={{ marginLeft: "0.8rem", marginRight: "0.8rem" }}>
                                            <div className="px-1 py-3">
                                                <div className="container1">
                                                    <div className="row">
                                                        <div className=" col-xs-12 bg-white ">
                                                            <div className="col-xl-9 col-lg-12 col-md-12 col-sm-12">
                                                                <div className="icueSearchBox w-85 mx-3" style={{ marginTop: "-20px" }} >
                                                                    <div className="input-group " style={{ marginLeft: "-20px" }}>
                                                                        <input type="search" className="search form-control icueSearchBoxControl" placeholder="Search Users by Name, Email or Date" aria-label="Username" aria-describedby="basic-addon1" style={{ backgroundColor: "#F4F7FC" }} />
                                                                        <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12">
                                                                            <a href="" type="button" className=" icueBgPrimary text-white pt-2 " data-bs-toggle="modal" data-bs-target="#addid" style={{ marginLeft: "12.5rem", width: "7.5rem", textAlign: "center", fontSize: "0.75rem", marginTop: "0.8rem", display: "inline-block", height: "35px" }}><i className="bi bi-plus-circle"></i> &nbsp;Add Member</a>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <form id="icueHrInfoForm">
                                                        <table id="icueHrTable" className="table results table-striped table-hover" style={{ width: "100%", border: "0", marginLeft: "-12px" }}>
                                                            <thead>
                                                                <tr className="text-uppercase" style={{ lineHeight: "15px", fontFamily: "Calibri", fontSize: "12px", backgroundColor: "#F4F7FC" }}>
                                                                    <th className="text-center py-3" >ID</th>
                                                                    <th className="text-center py-3">NAME</th>
                                                                    <th className="text-center py-3" >ROLE</th>
                                                                    <th className="text-center py-3">JOINED ON</th>
                                                                    <th className="text-center py-3">PERMISSIONS</th>
                                                                    <th className="text-center py-3">STATUS</th>
                                                                    <th className="text-center py-3">ACTIONS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody style={{ lineHeight: "15px", fontFamily: "Calibri", fontSize: "12px", textAlign: "center" }}>

                                                                {contacts.map((contact) => (
                                                                    <Fragment>
                                                                        {editContactId === contact.code ? (
                                                                            <EditableRow
                                                                                editFormData={editFormData}
                                                                                handleEditFormChange={handleEditFormChange}
                                                                                handleCancelClick={handleCancelClick}
                                                                            />
                                                                        ) : (
                                                                            <ReadOnlyRow
                                                                                contact={contact}
                                                                                handleEditClick={handleEditClick}
                                                                                handleDeleteClick={handleDeleteClick}
                                                                            />
                                                                        )}
                                                                    </Fragment>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* <!-- Add Details Modal --> */}
                                <div className="modal" id="addid" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog  modal-dialog-centered">
                                        <div className="modal-content rounded-3">
                                            <div className="modal-header d-flex flex-column" id="addModalHeader">
                                                <div className="text-end w-100" >
                                                    <button type="button" className="btn text-muted " data-bs-dismiss="modal" ><i className="bi bi-x-circle" style={{ color: "white" }}></i></button>
                                                </div>
                                                <div className="text-center">
                                                    <h4 className="modal-title">Add Member</h4>
                                                    <p className="text-muted">Please add a valid email</p>
                                                </div>
                                            </div>
                                            <div className="modal-body" id="addModalBody">
                                                <form className="">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-group pb-2">
                                                                <input className="form-control" type="text" name="icueAddMemEmail" onChange={handleAddFormChange} placeholder="Enter Email" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-group pb-2">
                                                                <input className="form-control" type="text" name="icueAddMemEmpCode" placeholder="Employee Code" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-group pb-2">
                                                                <select className="form-select text-muted" aria-label="icueAddDepartment">
                                                                    <option>Department</option>
                                                                    <option value="marketing">Marketing</option>
                                                                    <option value="operations">Operations</option>
                                                                    <option value="finance">Finance</option>
                                                                    <option value="sales">Sales</option>
                                                                    <option value="it">IT</option>
                                                                    <option value="human resource">Human Resource</option>
                                                                    <option value="purchase">Purchase</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-group pb-2">
                                                                <select className="form-select text-muted" aria-label="icueAddRole">
                                                                    <option>Role</option>
                                                                    <option value="1">Member</option>
                                                                    <option value="2">Team Lead</option>
                                                                    <option value="3">Manager</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <span className="text-muted">Permissions: </span>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueAddNotifyNewUserByMail" checked />
                                                                <label className="form-check-label text-muted" for="icueNotifyNewUserByMail">
                                                                    Notify new users by email
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueAddCanManageUsers" />
                                                                <label className="form-check-label text-muted" for="icueCanManageUsers">
                                                                    Can manage users
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueAddClaimManag" />
                                                                <label className="form-check-label text-muted" for="icueClaimManag">
                                                                    Claim management
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueAddPolicyManag" />
                                                                <label className="form-check-label text-muted" for="icuePolicyManag">
                                                                    Policy management
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueAddAccManag" />
                                                                <label className="form-check-label text-muted" for="icueAccManag">
                                                                    Account management
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 py-3">
                                                            <div className="d-grid gap-2">
                                                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                                                    Send Invite
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- /Add Details Modal -->

<!-- Edit Details Modal --> */}
                                <div className="modal fade" id="id" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog  modal-dialog-centered">
                                        <div className="modal-content rounded-3">
                                            <div className="modal-header d-flex flex-column" id="EditModalHeader">
                                                <div className="text-end w-100">
                                                    <button type="button" className="btn text-muted" data-bs-dismiss="modal"><i className="bi bi-x-circle"></i></button>
                                                </div>
                                                <div className="text-center">
                                                    <h4 className="modal-title">Edit Member</h4>
                                                    <p className="text-muted"></p>
                                                </div>
                                            </div>
                                            <div className="modal-body" id="editModalBody">
                                                <form className="">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-group pb-2">
                                                                <input className="form-control" type="text" name="icueEditMemEmail" placeholder="Enter Email" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-group pb-2">
                                                                <input className="form-control" type="text" name="icueEditMemEmpCode" placeholder="Employee Code" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-group pb-2">
                                                                <select className="form-select text-muted" aria-label="icueEditDepartment">
                                                                    <option>Department</option>
                                                                    <option value="marketing">Marketing</option>
                                                                    <option value="operations">Operations</option>
                                                                    <option value="finance">Finance</option>
                                                                    <option value="sales">Sales</option>
                                                                    <option value="it">IT</option>
                                                                    <option value="human resource">Human Resource</option>
                                                                    <option value="purchase">Purchase</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-group pb-2">
                                                                <select className="form-select text-muted" aria-label="icueEditRole">
                                                                    <option>Role</option>
                                                                    <option value="1">Member</option>
                                                                    <option value="2">Team Lead</option>
                                                                    <option value="3">Manager</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <span className="text-muted">Permissions: </span>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueEditNotifyNewUserByMail" checked />
                                                                <label className="form-check-label text-muted" for="icueEditNotifyNewUserByMail">
                                                                    Notify new users by email
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueEditCanManageUsers" />
                                                                <label className="form-check-label text-muted" for="icueEditCanManageUsers">
                                                                    Can manage users
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueEditClaimManag" />
                                                                <label className="form-check-label text-muted" for="icueClaimManag">
                                                                    Claim management
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueEditPolicyManag" />
                                                                <label className="form-check-label text-muted" for="icuePolicyManag">
                                                                    Policy management
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                                            <div className="form-check pb-2">
                                                                <input className="form-check-input" type="checkbox" id="icueEditAccManag" />
                                                                <label className="form-check-label text-muted" for="icueAccManag">
                                                                    Account management
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 py-3">
                                                            <div className="d-grid gap-2">
                                                                <button type="button" className="btn btn-primary btnIcon">
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- /Edit Details Modal -->

<!-- Delete Details Modal --> */}
                                <div className="modal fade" id="deleteid" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content  rounded-3">
                                            <div className="modal-header d-flex flex-column" id="deleteModalHeader">
                                                <div className="text-end w-100">
                                                    <button type="button" className="btn text-muted" data-bs-dismiss="modal"><i className="bi bi-x-circle"></i></button>
                                                </div>
                                                <div className="text-center">
                                                    <h4 className="modal-title">Delete Member</h4>
                                                </div>
                                            </div>
                                            <div className="modal-body" id="deleteModalBody">
                                                <form className="">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <div className="form-group">
                                                                <h4 className="text-danger text-center">Are you sure, delete this row</h4>
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="text-center">
                                                                <button type="button" className="btn btn-danger">Delete</button>
                                                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- /Delete Details Modal --> */}


                        </main>
                    </div>
                </div>
            </div >
        </div >


    )
}